import { afterEvent, defineGameCard, heatsUp } from '../authoring/index.js';
export const ArcConductorCard = defineGameCard({
    id: 'arc_conductor',
    gameplay: {
        type: 'UNIT', cost: 3,
        baseStats: { attack: 3, health: 4 }, keywords: ['RUSH'],
    },
    presentation: {
        name: 'Проводник дуги',
        description: 'Натиск. Греется. Раз за раунд, когда полностью охлаждается, наносит 3 урона.',
        glyph: {
            colors: ['#10213A', '#ABA8A8', '#F9AC19', '#484B4D', '#E15C0C'],
            rows: [
                '........1111........',
                '.......123321.......',
                '......12322221......',
                '......12322231......',
                '......14222341......',
                '.....1444334441.....',
                '.....1443344441.....',
                '.....1445235441.....',
                '.....1443235441.....',
                '.....1455555541.....',
                '.....1453225341.....',
                '.....1423323541.....',
                '.....1445355441.....',
                '.....1444324441.....',
                '.....1444234441.....',
                '......14322341......',
                '......12322221......',
                '......12222321......',
                '.......143341.......',
                '........1111........',
            ],
        },
    },
    role: 'playable',
    abilities: [
        heatsUp(),
        afterEvent({
            abilityId: 'first_full_cooling_arc',
            event: 'HeatChanged',
            frequency: 'first_per_round',
            when: (ctx, event) => ctx.self?.cellId !== undefined
                && event.instanceId === ctx.self.id
                && event.previous > 0
                && event.current === 0
                && event.reason === 'cooled',
            run: (ctx) => {
                const self = ctx.self;
                if (self?.cellId === undefined)
                    return;
                const opposite = ctx.q.opposingCell(self.cellId);
                const target = opposite === null ? null : ctx.q.unitAt(opposite.id);
                if (target !== null && target.controllerId !== self.controllerId) {
                    ctx.ops.dealDamage({ kind: 'unit', instanceId: target.id }, 3);
                }
                else {
                    ctx.ops.dealDamage({ kind: 'player', playerId: ctx.q.opponentOf(self.controllerId).id }, 3);
                }
            },
        }),
    ],
    ui: { mechanics: ['rush', 'heats_up', 'heat'] },
});
//# sourceMappingURL=arc-conductor.js.map